import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const linkCls = ({ isActive }) =>
  `whitespace-nowrap rounded-lg px-2.5 py-2 text-base font-semibold transition-colors ${isActive ? "text-[#A83232]" : "text-[#4A3B32] hover:text-[#A83232]"}`;

export const Logo = () => (
  <Link to="/" data-testid="header-logo-link" className="flex shrink-0 items-center gap-3">
    <img src="/img/logo.jpg" alt="" className="h-11 w-11 rotate-[-4deg] rounded-sm border-4 border-white shadow-md" />
    <span className="whitespace-nowrap font-serif text-xl font-bold leading-none text-[#4A2A18] sm:text-2xl">Voices 2 Remember</span>
  </Link>
);

export const Header = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const links = (
    <>
      <NavLink to="/#how" className={linkCls} data-testid="nav-how-link" onClick={() => setOpen(false)}>How it works</NavLink>
      <NavLink to="/examples" className={linkCls} data-testid="nav-examples-link" onClick={() => setOpen(false)}>Examples</NavLink>
      <NavLink to="/tips" className={linkCls} data-testid="nav-tips-link" onClick={() => setOpen(false)}>Filming tips</NavLink>
      <NavLink to="/affiliates" className={linkCls} data-testid="nav-affiliate-link" onClick={() => setOpen(false)}>Affiliate</NavLink>
      {user && <NavLink to="/orders" className={linkCls} data-testid="nav-orders-link" onClick={() => setOpen(false)}>My keepsakes</NavLink>}
      {user && <NavLink to="/account" className={linkCls} data-testid="nav-account-link" onClick={() => setOpen(false)}>Account</NavLink>}
      {user?.role === "admin" && <NavLink to="/admin" className={linkCls} data-testid="nav-admin-link" onClick={() => setOpen(false)}>Admin</NavLink>}
      {user ? (
        <button data-testid="nav-logout-button" className={linkCls({})} onClick={async () => { await logout(); setOpen(false); navigate("/"); }}>Sign out</button>
      ) : (
        <NavLink to="/login" className={linkCls} data-testid="nav-login-link" onClick={() => setOpen(false)}>Sign in</NavLink>
      )}
    </>
  );
  return (
    <header className="sticky top-0 z-40 border-b-2 border-[#E6DEC6] bg-[#FAF6F0]/95 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-0.5 xl:flex">
          {links}
          <Link to="/create" className="btn-primary ml-2 whitespace-nowrap !px-4 !py-2 !text-base" data-testid="nav-create-button">Create My Keepsake</Link>
        </nav>
        <button className="btn-secondary !min-h-0 !p-3 xl:hidden" aria-label="Menu" data-testid="nav-menu-toggle" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="flex flex-col gap-1 border-t-2 border-[#E6DEC6] px-4 pb-5 pt-2 xl:hidden" data-testid="mobile-nav">
          {links}
          <Link to="/create" className="btn-primary mt-2" data-testid="mobile-nav-create-button" onClick={() => setOpen(false)}>Create My Keepsake</Link>
        </nav>
      )}
    </header>
  );
};
